import React from 'react';

import * as actions from './broker/actions';
import * as components from './broker/components';
import { Link } from 'operation-diameter';

export default {
  eligibility: {
    title: 'Get started',
    subtitle:
      'To get started, simply answer a few questions to see if your client is eligible.',
    'quotation-credit-search-copy':
      'We will do a quotation credit search on on your client’s business and give you an indication of the risk profile, rate and fee structure.',

    'loan-amount': {
      title: 'How much would your client like to borrow?',
      label: 'Amount',
      status: 'You can borrow from £10,000 to £500,000.',
      status_increased: 'You can borrow from £10,000 to £750,000.'
    },
    commission: {
      title: 'How much is your commission?',
      label: 'Enter your commission'
    },
    term: {
      title: 'How long would your client like to borrow for?',
      label: 'Over how long?',
      loading: 'Loading the loan term input'
    },

    'business-structure': {
      title: 'What type of business does your client have?'
    },

    'company-search': {
      heading: 'What is the name of your client’s business or company number?',
      label: 'Company name / number',
      status:
        'If you can’t find the company name, try using the company registration number.'
    },

    email: {
      title: 'What’s your client’s email address?',
      disclaimer:
        'Although all communication about the loan application will be sent directly to you, and not to your client, we hold the right to contact your client to confirm you have the authority to act on their behalf.',

      label:
        "Enter your client's email address. Client must be a director of the business.",
      alreadyExists: () => (
        <>
          <Link href='/login'>click here</Link> to log in!
        </>
      )
    }
  },
  actions: {
    ...actions
  },
  shared: {
    errorPage: {
      title: 'Sorry, that didn’t work as expected',
      loanAppError: {
        paragraph:
          'We can’t seem to process your application at the moment. Please click the button below to try again now.',
        secondParagraph:
          'If you still experience issues, we recommend coming back in a few hours.',
        upperParagraph:
          'We can’t seem to process your client’s application at the moment.',
        lastParagraph: 'We recommend coming back in a few hours.',
        button: 'Try again'
      },
      nonLoanAppError: {
        paragraph:
          'We can’t seem to process your application at the moment but please try again later.'
      }
    }
  },
  components: {
    ...components
  }
};
